import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import "./plugins/firebase"
import "./plugins/vuefire"
import titleMixin from './mixins/titleMixin'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import './assets/custom.scss'

Vue.use(BootstrapVue, IconsPlugin)
Vue.mixin(titleMixin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
